module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[16]15.9fd42fe.woff2";